module.exports = __webpack_public_path__ + "d90fa984926d3745c7e68bc525692c26.otf";